//import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

const margin = { margin: '5px 0px' };

export default class FMPText extends PureComponent {
	render() {
		const { label, value, onChange, path, error, contained, helpText, multiline, md, disabled } = this.props;

		//let value, onChange, error;
		const hasError = !!error;
		const _onChange = (event) => onChange(event.target.value, path);

		const content = (
			<Grid item xs={12} md={md} style={{ margin }}>
				<FormControl fullWidth={true} error={hasError} disabled={disabled}>
					{!multiline && (
						<TextField
							error={hasError}
							disabled={disabled}
							value={value}
							onChange={_onChange}
							label={label}
							fullWidth
						/>
					)}

					{multiline && (
						<TextField
							error={hasError}
							disabled={disabled}
							value={value}
							onChange={_onChange}
							label={label}
							multiline
							rows={multiline}
							fullWidth
							variant="outlined"
						/>
					)}

					{hasError && <FormHelperText>{error}</FormHelperText>}
					{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		);

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FMPText.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,

	error: PropTypes.string,
	helpText: PropTypes.string,
	disabled: PropTypes.bool,
	multiline: PropTypes.number,

	contained: PropTypes.bool,
	md: PropTypes.number,
};

FMPText.defaultProps = {
	contained: true,
	md: 12,
};
